import React from 'react';
import { ShoppingCartIcon, HomeIcon } from 'lucide-react';
export const Header = ({
  onCartClick,
  onHomeClick
}) => {
  return <header className="w-full py-4 px-6 flex justify-between items-center border-b border-gray-200 bg-white" data-id="element-156">
      <div className="flex items-center" data-id="element-157">
        <button onClick={onHomeClick} className="mr-4 hover:text-[#5c5cf5] transition-colors" aria-label="Go to home" data-id="element-158">
          <HomeIcon size={24} className="text-gray-800" data-id="element-159" />
        </button>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7Frqi3Qp7tZbKVGUnkz12Q/Screenshot_2025-08-08_at_5.52.22_PM.png" alt="Veritran Logo" className="h-8 mr-3" data-id="element-160" />
        <div data-id="element-161">
          
        </div>
      </div>
      <button className="text-black p-2" onClick={onCartClick} aria-label="Shopping cart" data-id="element-162">
        <ShoppingCartIcon size={24} data-id="element-163" />
      </button>
    </header>;
};